import { useAuth } from '@/contexts/AuthContext';
import React from 'react';
import styles from './ProfileModal.module.scss';

const BrandContent: React.FC = () => {
    const { profile } = useAuth();
    // Assuming the active shop is the one with physicFlag === 1, or just the first one if not specified
    // In design it shows static text, here we map to real data.
    const brandInfo = profile?.shopInfos?.find(item => item.physicFlag === 1) || profile?.shopInfos?.[0];

    return (
        <div className={styles.brandContent}>
            <div className={styles.brandForm}>
                <div className={styles.formField}>
                    <label className={styles.fieldLabel}>Brand Name</label>
                    <div className={styles.fieldValue}>{brandInfo?.brandName || '-'}</div> 
                </div>

                <div className={styles.formField}>
                    <label className={styles.fieldLabel}>Store URL</label>
                    <div className={styles.fieldValue}>{brandInfo?.domain || '-'}</div>
                </div>
            </div>
        </div>
    );
};

export default BrandContent;